import script from "./AdminTemplates.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminTemplates.vue?vue&type=script&setup=true&lang=js"

import "./AdminTemplates.vue?vue&type=style&index=0&id=1e56bd75&scoped=true&lang=css"
import "./AdminTemplates.vue?vue&type=style&index=1&id=1e56bd75&lang=css"

import exportComponent from "D:\\Pragmasoft\\zntry.consent\\src\\Zntry.Consent.Website\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e56bd75"]])

export default __exports__